import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import classNames from 'classnames/bind';
import { ReactNode, TextareaHTMLAttributes, useState } from 'react';

import styles from './styles.module.scss';

interface Props extends TextareaHTMLAttributes<HTMLInputElement|HTMLTextAreaElement> {
    showLength?: boolean;
    textAlign?: 'left' | 'center' | 'right';
    value?: string,
    setValue?: (value: string) => void;
    as?: 'input'|'textarea';
    min?: number;
    max?: number;
    trailing?: ReactNode;
    helperText?: string;
    errorText?: string;
}

const cx = classNames.bind(styles);

function TextField(props: Props) {
    const {
        showLength, textAlign = 'left', setValue,
        value, maxLength, min, max,
        as: Component = 'input',
        onChange, trailing, helperText,
        className, errorText, ...rest
    } = props;
    const [length, setLength] = useState<number>(0);
    return (
        <Container>
            <Contents>
                <Component className={cx(
                    'input',
                    `align-${textAlign}`,
                    className,
                )}
                value={value}
                maxLength={maxLength}
                min={min}
                max={max}
                onChange={(e) => {
                    setValue?.(e.target.value);
                    setLength(e.target.value.length);
                    onChange?.(e);
                }}
                {...rest} />
                {showLength && (
                    <Count isTextarea={Component === 'textarea'}>
                        {length} /  {maxLength}
                    </Count>
                )}
                {trailing && (
                    <Trailing>{trailing}</Trailing>
                )}
            </Contents>
            {helperText && (
                <Text color={colors.gray6} size='s'>{helperText}</Text>
            )}
            {errorText && (
                <Text color={colors.red} size='s'>{errorText}</Text>
            )}
        </Container>
    );
}

const Count = styled.span<{
    isTextarea?: boolean;
}>`
    color: var(--color-gray8);
    font-size: 14px;
    position: absolute;
    right: 20px;
    bottom: ${({ isTextarea }) => (isTextarea ? '20px' : 'unset')};
`;

const Contents = styled.div`
    align-items: center;
    display: flex;
    position: relative;
    width: 100%;
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
`;

const Trailing = styled.div`
    position: absolute;
    right: 0;
`;

export default TextField;
